import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

import './index.css';
import './mui-override.scss';
import App from './App';
import { isChunkError, recentlyReloaded, markReload } from './utils/chunkReload';

// Global safeguard: catch ChunkLoadError (and similar dynamic-import failures)
// that escape React render boundaries — e.g. async chunk requests fired from
// outside the component tree, or rejections that aren't .catch'd anywhere.
window.addEventListener('error', (e) => {
  const err = (e && e.error) || { message: e && e.message };
  if (isChunkError(err) && !recentlyReloaded()) {
    markReload();
    window.location.reload();
  }
});
window.addEventListener('unhandledrejection', (e) => {
  const reason = e && e.reason;
  if (isChunkError(reason) && !recentlyReloaded()) {
    markReload();
    window.location.reload();
  }
});

ReactDOM.render(
  <BrowserRouter>
    <Routes>
      <Route path="/*" element={<App />} />
    </Routes>
  </BrowserRouter>,
  document.getElementById('root'),
);
